import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../cn.js';
export function Icon({ name, fill = false, weight = 400, className, style, ...rest }) {
    const variation = `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' 24`;
    return (_jsx("span", { "aria-hidden": "true", "data-icon": name, className: cn('material-symbols-outlined select-none', className), style: { fontVariationSettings: variation, ...style }, ...rest, children: name }));
}
//# sourceMappingURL=Icon.js.map